import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectImagePath } from "reducers/ui";

interface MetaTag {
    name?: string;
    property?: string;
    content: string;
}

interface LinkTag {
    rel: string;
    href: string;
}

interface MetadataConfig {
    title?: string;
    meta?: MetaTag[];
    links?: LinkTag[];
}

const Metadata: React.FC = () => {
    const imagePath = useSelector(selectImagePath);

    useEffect(() => {
        if (imagePath) {
            fetch(`${imagePath}/metadata.json`)
                .then((res) => res.json())
                .then((data: MetadataConfig) => {
                    if (data.title) {
                        document.title = data.title;
                        // Store the title for protection from Google Translate
                        sessionStorage.setItem('original_page_title', data.title);
                    }

                    if (Array.isArray(data.meta)) {
                        data.meta.forEach((m) => {
                            const selector = m.name
                                ? `meta[name="${m.name}"]`
                                : m.property
                                    ? `meta[property="${m.property}"]`
                                    : null;

                            let element: Element | null = selector
                                ? document.head.querySelector(selector)
                                : null;

                            if (!element) {
                                element = document.createElement("meta");
                                document.head.appendChild(element);
                            }

                            Object.entries(m).forEach(([key, value]) => {
                                (element as HTMLElement).setAttribute(
                                    key,
                                    value.replace("%PUBLIC_URL%", window.location.origin)
                                );
                            });
                        });
                    }

                    // Handle <link> tags
                    if (Array.isArray(data.links)) {
                        data.links.forEach((l) => {
                            const selector = l.rel ? `link[rel="${l.rel}"]` : null;
                            let element: Element | null = selector
                                ? document.head.querySelector(selector)
                                : null;

                            if (!element) {
                                element = document.createElement("link");
                                document.head.appendChild(element);
                            }

                            Object.entries(l).forEach(([key, value]) => {
                                (element as HTMLElement).setAttribute(
                                    key,
                                    value.replace("%PUBLIC_URL%", window.location.origin)
                                );
                            });
                        });
                    }
                })
                .catch((err) => console.error("Error loading metadata.json:", err));
        }
    }, [imagePath]);

    return null;
};

export default Metadata;
